/* The Journal: groups an entry's text into chapters, opens film-strip frames on touch, and draws the reading line. */
(() => {
  const body = document.querySelector('[data-lj-body]');

  /* ---------- Chapters: heading and margin notes on the left, text on the right ---------- */
  if (body && body.querySelector('h2')) {
    const kids = [...body.children];
    body.textContent = '';
    let side;
    let text;
    const start = () => {
      const chapter = document.createElement('section');
      chapter.className = 'lj-ch';
      side = document.createElement('div');
      side.className = 'lj-ch__side';
      text = document.createElement('div');
      text.className = 'lj-ch__text';
      chapter.append(side, text);
      body.append(chapter);
    };
    start();
    kids.forEach((el, i) => {
      if (el.matches('h2')) {
        if (i > 0) start();
        side.append(el);
      } else if (el.matches('.lj-note')) {
        side.append(el);
      } else {
        text.append(el);
      }
    });
    body.classList.add('is-chaptered');
  }

  /* ---------- Film strip: on a phone, the frame nearest the middle opens ---------- */
  const strip = document.querySelector('.lj-strip');
  if (strip && window.matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
    const frames = [...strip.querySelectorAll('.lj-frame')];
    const io = new IntersectionObserver((entries) => entries.forEach((e) => {
      if (e.isIntersecting) frames.forEach((f) => f.classList.toggle('is-open', f === e.target));
    }), { root: strip, rootMargin: '0px -45% 0px -45%' });
    frames.forEach((f) => io.observe(f));
  }

  /* ---------- Reading line under the header ---------- */
  const line = document.querySelector('[data-lj-progress]');
  if (line && body) {
    let ticking = false;
    const update = () => {
      ticking = false;
      const r = body.getBoundingClientRect();
      const span = Math.max(1, r.height - window.innerHeight * 0.5);
      line.style.setProperty('--lj-read', Math.min(1, Math.max(0, (window.innerHeight * 0.5 - r.top) / span)).toFixed(4));
    };
    const ask = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    document.addEventListener('scroll', ask, { passive: true, capture: true });
    window.addEventListener('resize', ask);
    update();
  }
})();
